export const Layout = {
  // Container width constraints
  containerWidth: '100%',
  containerMaxWidth: '100%',

  // Content width (for centering content on larger screens)
  contentMaxWidth: '1200px',

  // Standard padding
  sidesPadding: '24px',
  verticalPadding: '16px',

  // Navigation
  navHeight: '80px',

  // Spacing
  gapSmall: '8px',
  gapMedium: '12px',
  gapLarge: '16px',
  gapXLarge: '24px',

  // Border radius
  radiusSmall: '8px',
  radiusMedium: '12px',
  radiusLarge: '16px',
  radiusXLarge: '20px',

  // Hero section
  heroHeight: 300,

  // Shadow
  shadowSmall: '0 1px 4px rgba(0, 0, 0, 0.05)',
  shadowMedium: '0 2px 8px rgba(0, 0, 0, 0.05)',
  shadowLarge: '0 4px 12px rgba(0, 0, 0, 0.1)',

  // Typography
  fontSizeSmall: '12px',
  fontSizeSmallPlus: '14px',
  fontSizeMedium: '16px',
  fontSizeLarge: '20px',
  fontSizeXLarge: '22px',
  fontSizeXXLarge: '32px',
} as const;
